<div class="flyout-submitted-form-component">
  <div class="flyout-data-group">
    <mat-expansion-panel [expanded]="!expandedTab || expandedTab === 'submitted-form'" class="mat-elevation-z0">
      <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
        <img class="header-icon" src="/assets/img/icons_fl/user-analytics.svg" width="32px" height="32px" />
        <span>{{ "flyout.submitted-form" | translate }}</span>
      </mat-expansion-panel-header>

      @if (personalData?.email) {
        <div class="expansion-panel-row header">
          <div class="label cell">
            <img class="label-icon" src="/assets/img/icons_fl/email.svg" width="24px" height="24px" />
            <span class="email-item">{{ "flyout.contact-info.email" | translate }}</span>
          </div>
          <div class="value cell">
            <span [innerHTML]="personalData?.email"></span>
          </div>
        </div>
      }

      @if (arrSubmittedForm.length) {
        @for (property of arrSubmittedForm; track property) {
          <div class="expansion-panel-row values">
            <div class="label cell">
              <span>{{ property.label }}</span>
            </div>
            <div class="value cell">
              @if (property.key === WidgetComponentSubType.ButtonListStarRating && property.originalValue && property?.originalValue[0]) {
                <div class="wrapper-star">
                  @for (star of property.originalValue; track $index) {
                    <svg
                      fill="rgb(252, 207, 10)"
                      class="star-svg"
                      id="Layer_2"
                      data-name="Layer 2"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 48.76 46.54">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <path
                          class="cls-1"
                          d="m25.9.95l6.22,12.6c.25.5.73.85,1.28.93l13.9,2.02c1.39.2,1.95,1.91.94,2.9l-10.06,9.81c-.4.39-.58.95-.49,1.5l2.37,13.85c.24,1.39-1.22,2.45-2.46,1.79l-12.44-6.54c-.49-.26-1.09-.26-1.58,0l-12.44,6.54c-1.25.66-2.7-.4-2.46-1.79l2.37-13.85c.09-.55-.09-1.11-.49-1.5L.51,19.39c-1.01-.98-.45-2.7.94-2.9l13.9-2.02c.55-.08,1.03-.43,1.28-.93L22.86.95c.62-1.26,2.42-1.26,3.05,0Z" />
                      </g>
                    </svg>
                  }
                  @for (star of property.total; track $index) {
                    <svg
                      fill="rgba(144, 144, 144, 0.7)"
                      class="star-svg"
                      id="Layer_2"
                      data-name="Layer 2"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 48.76 46.54">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <path
                          class="cls-1"
                          d="m25.9.95l6.22,12.6c.25.5.73.85,1.28.93l13.9,2.02c1.39.2,1.95,1.91.94,2.9l-10.06,9.81c-.4.39-.58.95-.49,1.5l2.37,13.85c.24,1.39-1.22,2.45-2.46,1.79l-12.44-6.54c-.49-.26-1.09-.26-1.58,0l-12.44,6.54c-1.25.66-2.7-.4-2.46-1.79l2.37-13.85c.09-.55-.09-1.11-.49-1.5L.51,19.39c-1.01-.98-.45-2.7.94-2.9l13.9-2.02c.55-.08,1.03-.43,1.28-.93L22.86.95c.62-1.26,2.42-1.26,3.05,0Z" />
                      </g>
                    </svg>
                  }
                </div>
              }
              @if (property.key === WidgetComponentSubType.ButtonListNpsRating && property.value) {
                <span class="wrapper-nps value-text" [ngClass]="property.typeValue === 'number' ? 'marker-number' : null">
                  {{ property.value }}
                </span>
              }
              @if (property.key === WidgetComponentSubType.ButtonListThumbRating && property.value) {
                <div class="wrapper-thumb">
                  @if (property.originalValue === "Very disappointed" || property.originalValue === "Mycket missnöjd") {
                    <img class="thumb-img" [src]="'https://widget-resources.triggerbee.com/library/presets/thumbs/rating-thumbs-down2.svg'" alt="" />
                  }
                  @if (property.originalValue === "Very satisfied" || property.originalValue === "Mycket nöjd") {
                    <img class="thumb-img" [src]="'https://widget-resources.triggerbee.com/library/presets/thumbs/rating-thumbs-up2.svg'" alt="" />
                  }
                </div>
              }
              @if (property.key !== WidgetComponentSubType.ButtonListNpsRating) {
                <span>
                  <span class="value-text" [innerHTML]="property.value"></span>
                </span>
              }
            </div>
          </div>
        }
      }
    </mat-expansion-panel>
  </div>
</div>
